export const BGC_FIELDS = {
  compliance_list: 'compliance_list',
  negative_media: 'negative_media',
  pep: 'pep',
  process_data: 'process_data',
  restriction_data: 'restriction_data',
  risk_score: 'risk_score',
  job_role: 'job_role',
  occupation_area: 'occupation_area',
  family_relation_data: 'family_relation_data',
  company_data: 'company_data',
  credit_score_data: 'credit_score_data',
  financial_pendings_data: 'financial_pendings_data',
}

export const SCORE_PARTICIPANTS = [
  'compliance_list',
  'negative_media',
  'pep',
  'process_data',
  'restriction_data',
  'job_role',
  'occupation_area',
]

export const REVIEW_THEMES = {
  negative_media: 'Mídia Negativa',
  process_data: 'Processos',
  score_board: 'Score da Aplicação',
  company_data: 'Participações Societárias',
  financial_pendings_data: 'Pendências Financeiras',
  family_relation_data: 'Relações Familiares',
}
